import React from 'react';
import Navbar from '../components/Navbar';
import PilotHero from '../components/PilotHero';
import PilotFeatures from '../components/PilotFeatures';
import PilotDashboardPreview from '../components/PilotDashboardPreview';

const PilotPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <Navbar />
      <main>
        <PilotHero />
        
        {/* Value Prop Highlight */}
        <section className="py-24 bg-white border-y border-gray-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6">
              Command Your Event. <span className="text-indigo-600">Reclaim Your Time.</span>
            </h2>
            <p className="text-gray-600 text-xl max-w-3xl mx-auto mb-10 leading-relaxed">
              Why juggle five different tools when you can Pilot everything from one? We've reduced event configuration time by 72%, allowing you to focus on what matters: your attendees.
            </p>
            <div className="flex justify-center">
              <div className="bg-indigo-50 px-12 py-8 rounded-2xl border border-indigo-100 max-w-lg">
                <p className="text-indigo-600 font-black text-5xl mb-2">72%</p>
                <p className="text-indigo-900 font-bold uppercase tracking-wider text-sm">REDUCTION IN SETUP OVERHEAD</p>
              </div>
            </div>
          </div>
        </section>

        <PilotFeatures />
        <PilotDashboardPreview />
      </main>
    </div>
  );
};

export default PilotPage;